import { Theme } from '@mui/material/styles';

interface Position {
  x: number;
  y: number;
}

interface Rect {
  width: number;
  height: number;
}

export const getStepIconColor = (theme: Theme, active: boolean, completed: boolean) => {
  if (active) {
    return theme.palette.primary.main;
  }
  if (completed) {
    return theme.palette.success.main;
  }
  return theme.palette.mode === 'dark'
    ? theme.palette.grey[700]
    : theme.palette.grey[300];
};

export const getStepIconTextColor = (
  theme: Theme,
  active: boolean,
  completed: boolean,
) => {
  if (active || completed) {
    return theme.palette.common.white;
  }
  return theme.palette.mode === 'dark'
    ? theme.palette.grey[300]
    : theme.palette.text.primary;
};

export const getProgressBarWidth = (activeStep: number, totalSteps: number) => {
  return `${((activeStep + 1) / totalSteps) * 100}%`;
};

export const calculateNewPosition = (
  currentPosition: Position,
  elementRect: Rect,
  viewportWidth: number,
  viewportHeight: number,
): Position => {
  return {
    x: Math.max(0, Math.min(currentPosition.x, viewportWidth - elementRect.width)),
    y: Math.max(0, Math.min(currentPosition.y, viewportHeight - elementRect.height)),
  };
};

export const hasPositionChanged = (
  oldPosition: Position,
  newPosition: Position,
): boolean => {
  return oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y;
};
